<template>
	<CardGrafico :subtitle="updatedAt">
		<template #grafico>
			<Loading v-if="series.length === 0" />
			<div
				v-else
				class="container__grafico__dispersao"
			>
				<slot name="action-buttons" />
				<Chart
					id="dispersao__parcelas"
					ref="ref__chart"
					:update-args="[chartOptions, true]"
					:options="chartOptions"
				/>
			</div>
		</template>
	</CardGrafico>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Loading from '../../components/Loading/Loading'
import CardGrafico from '../CardGrafico/CardGrafico'

// import _ from "lodash";

import { stringToExportCSV } from '../../utils/csvHellpers'

export default {
	components: { CardGrafico, Loading, Chart },
	props: {
		/**
		 * Dados que devem ir para o grafico
		 */
		infoGrafico: { type: Object },
		series: { type: Array, required: true },
		updatedAt: { type: String, required: false, default: '' },
	},
	data() {
		console.log('infooo', this.infoGrafico)
		return {
			dropdownTipoGrafico: 'vtcc',
			dropdownDownload: '',
			parcelasTemporarias: [],
			chartScopes: [
				{ label: 'Altura Dominante', value: 'alturaDominante' },
				{ label: 'VTCC', value: 'vtcc' },
				{ label: 'VTSC', value: 'vtsc' },
				{ label: 'Área Basal', value: 'areaBasal' },
				{ label: 'Diâmetro Médio', value: 'diametroMedio' },
			],
		}
	},
	computed: {
		/**
		 * Options para configuracao do grafico
		 */
		chartOptions() {
			return {
				chart: {
					type: 'scatter',
					zoomType: 'xy',
					// redraw: true
				},
				title: {
					text: 'Resíduos',

					style: {
						fontSize: '100%',
					},
				},
				subtitle: {
					text: '',
				},
				xAxis: {
					title: {
						enabled: true,
						text: 'Idade (meses)',
						style: {
							fontSize: '100%',
						},
					},

					startOnTick: true,
					endOnTick: true,
					showLastLabel: true,
				},
				yAxis: {
					title: {
						text: 'Resíduos ' + this.infoGrafico?.unidade,
						style: {
							fontSize: '100%',
						},
					},

					// tickInterval: 20,
					plotLines: [
						{
							color: 'red',
							width: 2,
							value: 0,
						},
					],
				},
				legend: {
					layout: 'vertical',
					align: 'left',
					verticalAlign: 'top',
					x: 100,
					y: 70,
					floating: true,
					enabled: false,
					// backgroundColor: Highcharts.defaultOptions.chart.backgroundColor,
					borderWidth: 1,
				},
				plotOptions: {
					scatter: {
						marker: {
							radius: 5,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)',
								},
							},
						},
						states: {
							hover: {
								marker: {
									enabled: false,
								},
							},
						},
						tooltip: {
							positioner: function () {
								return { x: 40, y: 25 }
							},
							headerFormat: '<b>{point.codigoParcela}</b><br>',
							pointFormat: 'Idade: {point.x:.0f} Meses<br>' + 'Resíduos: {point.y:.3f} %',
						},
					},
					series: {
						allowPointSelect: true,
						point: {
							events: {
								select: function () {
									// this.parcelasTemporarias.push(this.id)

									this.series.data.find((e) => e.id === this.id).selected = true
									// var text = this.category + ': ' + this.y + ' was last selected'
									// var  chart = this.series.chart;
									// if (!chart.lbl) {
									//     chart.lbl = chart.renderer.label(text, 100, 70)
									//         .attr({
									//             padding: 10,
									//             r: 5,
									//             // fill: Highcharts.getOptions().colors[1],
									//             zIndex: 5
									//         })
									//         .css({
									//             color: '#FFFFFF'
									//         })
									//         .add();
									// } else {
									//     chart.lbl.attr({
									//         text: text
									//     });
									// }
								},
							},
						},
					},
				},

				series: [
					{
						name: 'Parcela',
						turboThreshold: Number.MAX_SAFE_INTEGER,
						// data: this.data.map(e => { return {x: e.idade, y: e.vtcc }})
						color: `rgb(149, 187, 73)`,
						data: this.dadosDispersao,
						animation: false,
					},
				],
			}
		},

		/**
		 * Prepara os dados para serem plotadas no grafico de dispersao
		 */
		dadosDispersao() {
			return this.series
		},

		/**
		 * Configuracao do grafico de acordo com o tipo exibido
		 */
		configuracaoDoGrafico() {
			if (this.dropdownTipoGrafico === 'vtcc') {
				return {
					tipoDoGrafico: 'Volume Total com Casca (m³/ha)',
					titulo: 'Volume Total com Casca por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'vtsc') {
				return {
					tipoDoGrafico: 'Volume Total sem Casca (m³/ha)',
					titulo: 'Volume Total sem Casca por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'alturaDominante') {
				return {
					tipoDoGrafico: 'Altura Dominante',
					titulo: 'Altura Dominante por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'areaBasal') {
				return {
					tipoDoGrafico: 'Área Basal',
					titulo: 'Área Basal por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else {
				return {
					tipoDoGrafico: 'Diâmetro Médio',
					titulo: 'Diâmetro Médio por faixa de idade',
					posicaoDataLabel: -55,
				}
			}
		},
	},
	watch: {
		/**
		 * Tipo do grafico que deve ser mostrado
		 * Área Plantada, Volume ou IMA
		 */
		dropdownTipoGrafico() {
			this.changeHighchartsOptions()
			this.$emit('tipoGrafico', this.dropdownTipoGrafico)
		},
		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},
	mounted() {
		const rgbDefaultColor = getComputedStyle(document.body).getPropertyValue('--color-default')
		this.chartOptions.series[0].color = `rgb(${rgbDefaultColor})`
	},

	methods: {},
}
</script>

<style scoped>
/* @import url("../../css/tooltipSimplesHighcharts.css"); */

.container__grafico__dispersao {
	display: block;
	flex-direction: column;
	height: 100%;
}

.highcharts-container {
	margin: 0 !important;
	height: 100% !important;
}

#dispersao__parcelas {
	height: 100%;
}
</style>
